import { CurrentUserService } from "./../../current-user.service";
import { environment } from "src/environments/environment";
import { ApiService } from "./../api.service";
import { Injectable } from "@angular/core";
import { Helpers } from "projects/training-calendar/src/app/helpers";
import { IRegistration } from "projects/cbc-msde/src/app/cbc-msde/models/IRegistration";
import { Observable } from "rxjs";


const TC_STATUS = Object.freeze({
	CREATED: "TC_CREATED",
	SEND_BACK: "Document Required",
	REJECTED: "Not Approved",
	APPROVED: "approved",
	RESUBMIT: "RESUBMIT",
	INACTIVE: "INACTIVE",
	CLOSED: "CLOSED",
});

@Injectable({ providedIn: 'root' })
export class UserService {
	constructor(
		private apiService: ApiService,
		private currentUserService: CurrentUserService
	) { }
	Query;
	URI;

	get TC_STATUS() {
		return TC_STATUS;
	}
	overrideAssessmentRequest(overideData) {
		const apiURL = environment.userServiceUrl + "";
		return this.apiService.put(apiURL, {});
	}
	getInspectionAgencies() {
		const apiURL =
			environment.userServiceUrl + "/api/user/v1/inspectionAgency";
		return this.apiService.get(apiURL);
	}
	tcUpdateForm(body, tcId?: string) {
		const userData = this.currentUserService.getCurrentUserLocal().value;
		if (userData && userData.hasOwnProperty("tcmobileappstatus")) {
			body["tcmobileappstatus"] = userData.tcmobileappstatus;
		}
		tcId = tcId || userData.userName;
		const queryString = Helpers.serialize({
			tcId,
		});
		const updateAPI = `${environment.userServiceUrl}/api/user/v1/trainingcentre/UpdateForm?${queryString}`;
		return this.apiService.patch(updateAPI, body, true);
		// const updateAPI = `${
		// 	environment.userServiceUrl
		// }/api/user/v1/trainingcentre/${userData.userName}/save/residentialfacility`;
		// return this.apiService.patch(updateAPI, body);
		// 	const updateAPI = `${
		// 	environment.userServiceUrl
		// }/api/user/v1/trainingcentre/UpdateForm?${queryString}`;
		// return this.apiService.patch(updateAPI, body);
	}
	setResidentialData(userName, ObjectTo) {
		let ObjectToSet = {
			men: false,
			women: false,
			transgender: false,
		};
		ObjectToSet = Object.assign({}, ObjectToSet, ObjectTo);
		localStorage.setItem("__" + userName, JSON.stringify(ObjectToSet));
	}
	getResidentialData(userName) {
		// localStorage.removeItem(JSON.stringify(userName));
		return localStorage.getItem("__" + userName);
	}
	residentialTCUpdate(body, tcId?: string) {
		const userData = this.currentUserService.getCurrentUserLocal().value;
		if (userData && userData.hasOwnProperty("tcmobileappstatus")) {
			body["tcmobileappstatus"] = userData.tcmobileappstatus;
		}
		tcId = tcId || userData.userName;
		const queryString = Helpers.serialize({
			tcId,
		});
		const updateAPI = `${environment.userServiceUrl}/api/user/v1/trainingcentre/${userData.userName}/save/residentialfacility`;
		return this.apiService.patch(updateAPI, body);
	}
	moblieStatus(userName) {
		const getAPI = `${environment.userServiceUrl}/mobile/tc/dashboardstatus?tcid=${userName}`;
		return this.apiService.get(getAPI);
	}
	residentialPostSavingForm(body, tcId?: string) {
		const userData = this.currentUserService.getCurrentUserLocal().value;
		if (userData && userData.hasOwnProperty("tcmobileappstatus")) {
			body["tcmobileappstatus"] = userData.tcmobileappstatus;
		}
		const updateAPI = `${environment.userServiceUrl}/api/user/v1/trainingcentre/${userData.userName}/save/residentialfacility`;
		return this.apiService.post(updateAPI, body);
	}
	tcUpdateMobileStatus(body) {
		const userData = this.currentUserService.getCurrentUserLocal().value;
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/UpdateForm";
		return this.apiService.patch(updateAPI, body, true);
	}
	tcUpdateDetails(body) {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/UpdateForm";
		return this.apiService.post(updateAPI, body, true);
	}
	addCentreArea(body) {
		const addCentreAreaAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/UpdateForm/AddCentreArea";
		return this.apiService.patch(addCentreAreaAPI, body, true);
	}
	addJobRole(body) {
		const addJobRoleAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/UpdateForm/AddJobRoles";
		return this.apiService.patch(addJobRoleAPI, body, true);
	}
	addCentreStaff(body) {
		const addJobRoleAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/UpdateForm/AddCentreStaff";
		return this.apiService.patch(addJobRoleAPI, body, true);
	}
	getSpocDetails(userId) {
		const getSpocAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/" +
			userId;
		// + '?fields=spoc,trainingPartner,trainingCentreName'
		return this.apiService.get(getSpocAPI);
	}

	getClassrooms(userId) {
		const classroomAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/" +
			userId +
			"?fields=classroom";
		return this.apiService.get(classroomAPI);
	}
	getlaboratories(userId) {
		const laboratoriesAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/" +
			userId +
			"?fields=laboratory";
		return this.apiService.get(laboratoriesAPI);
	}
	getHybrid(userId) {
		const hybridAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/" +
			userId +
			"?fields=hybrid";
		return this.apiService.get(hybridAPI);
	}
	getTrainer(userId) {
		const trainerAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/" +
			userId +
			"?fields=trainer";
		return this.apiService.get(trainerAPI);
	}
	getTrainingCentreAssessmentRequestByID(id) {
		const tcAssessmentAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/workflow/" +
			id;
		return this.apiService.get(tcAssessmentAPI);
	}
	getTrainerList() {
		const getTrainerUrl =
			environment.userServiceUrl + '/api/user/v1/user/trainers?pagination=no';
		return this.apiService.get(getTrainerUrl);
	}
	getTrainingCentreResidentialAssessmentRequestByID(id) {
		const tcAssessmentAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/residentialWorkFlow/" +
			id;
		return this.apiService.get(tcAssessmentAPI);
	}
	assignTCAssessmentToDA(userName, tcworkflowid, status, asignedNextUser) {
		const assessmentAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/approve/" +
			userName +
			"/" +
			tcworkflowid +
			"/" +
			status +
			"/" +
			asignedNextUser;
		return this.apiService.put(assessmentAPI, {});
	}
	assignVirtualInspection(tcworkflowid, payload) {
		const assessmentAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/inspectionagency/assign/virtualinspection/" + tcworkflowid
		return this.apiService.post(assessmentAPI, payload);
	}

	approveRplTcDesktopAssessment(tcworkflowid, payload) {
		const assessmentAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/desktopassesor/approve/" + tcworkflowid
		return this.apiService.post(assessmentAPI, payload, true);
	}
	assignTCAssessmentToResidentialDA(
		userName,
		tcworkflowid,
		status,
		asignedNextUser
	) {
		const assessmentAPI =
			environment.userServiceUrl +
			"/api/user/v1/residential/approve/" +
			userName +
			"/" +
			tcworkflowid +
			"/" +
			status +
			"/" +
			asignedNextUser;
		return this.apiService.put(assessmentAPI, {});
	}
	assignTCAssessmentChangeResidentialDA(dataToSend) {
		const assessmentAPI =
			environment.userServiceUrl + "/api/user/v1/residential/change/da";
		return this.apiService.post(assessmentAPI, dataToSend);
	}
	assignTPAssessmentToDA(tpworkflowid, asignedNextUser) {
		const assessmentAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingpartner/change/da/" +
			tpworkflowid +
			"/" +
			asignedNextUser;
		return this.apiService.get(assessmentAPI);
	}
	// tp re-da assisgnment API changed
	assignTPREAssessmentToDA(tpworkflowid, asignedNextUser) {
		const assessmentAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingpartner/reassign/da/" +
			tpworkflowid +
			"/" +
			asignedNextUser;
		return this.apiService.get(assessmentAPI);
	}
	assignTCChangeAssessmentToDA(data) {
		const assessmentAPI =
			environment.userServiceUrl + "/api/user/v1/change/da";
		return this.apiService.post(assessmentAPI, data);
	}
	TCUpdateApplication(userName, body) {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/PatchTC/" +
			userName;
		return this.apiService.patch(updateAPI, body);
	}
	TCUpdatePatchRequest(userName, body) {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/" +
			userName;
		return this.apiService.patch(updateAPI, body);
	}
	updateClassroom(userName, body) {
		const classroomUpdateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/mobile/UpdateForm/slice?param=classroom&tcid=" +
			userName;
		return this.apiService.patch(classroomUpdateAPI, body, true);
	}
	updateLaboratory(userName, body) {
		const laboratoryAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/mobile/UpdateForm/slice?param=laboratory&tcid=" +
			userName;
		return this.apiService.patch(laboratoryAPI, body, true);
	}
	updateHybrid(userName, body) {
		const hybridAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/mobile/UpdateForm/slice?param=hybrid&tcid=" +
			userName;
		return this.apiService.patch(hybridAPI, body, true);
	}
	getAssocoatedSchemes() {
		const schemeURL =
			environment.schemeServiceURL +
			"/api/schemes/v1/schemes/active/rule/Approved";
		return this.apiService.get(schemeURL);
	}
	getUserList() {
		const userAPI =
			environment.userServiceUrl + "/api/user/v1/holdingAgency";
		return this.apiService.get(userAPI);
	}
	createUserByAnotherUser(userRole, body, forNonAATC?) {
		const userAPI =
			environment.userServiceUrl + `/api/user/v1/register/${userRole}?forNonAATC=${forNonAATC}`;
		return this.apiService.post(userAPI, body);
	}
	updateTC(tcwId, body, isNonAATC) {
		let userAPI;
		if (isNonAATC) {
			userAPI = `${environment.userServiceUrl}/api/user/v1/trainingpartner/resubmit/nonAnATC`;
		} else {
			userAPI = environment.userServiceUrl + "/api/user/v1/rejectedTC/" + tcwId;
		}
		return this.apiService.patch(userAPI, body);
	}
	getTrainingCentreAssessmentRequest(id) {
		const getTCDetailsURL =
			environment.userServiceUrl + "/api/user/v1/trainingcentre/" + id;
		return this.apiService.get(getTCDetailsURL);
	}

	getJobRoleBySerialNumber(tcUserName, serialNumber) {
		const jobRoleTypeUrl =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/GetFromCaafForm/JobRole?tcID=" +
			tcUserName +
			"&serialNumber=" +
			serialNumber;
		return this.apiService.get(jobRoleTypeUrl);
	}

	submitDaApprovalForTc(tcUserName, dataToSend) {
		const approvalSubmitURL =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/caaf/" +
			tcUserName +
			"/reviews";
		return this.apiService.put(approvalSubmitURL, dataToSend, true);
	}
	getAffilationById(id) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingcentre/${id}`;
		return this.apiService.get(url);
	}

	assignCIDate(datatoSend) {
		const url = `${environment.userServiceUrl}/api/user/v1/traingcenter/addInspectiondate`;
		return this.apiService.put(url, datatoSend, true);
	}
	specialInspectionDate(payload) {
		const url = `${environment.userServiceUrl}/api/user/v1/traingcenter/insertInspectionDateExtension`;
		return this.apiService.post(url, payload);
	}
	smartAdminAction(payload) {
		const url = `${environment.userServiceUrl}/api/user/v1/traingcenter/updateInspectionDateExtension`;
		return this.apiService.post(url, payload);
	}
	getSpecialInspectionDate(query) {
		const url = `${environment.userServiceUrl}/api/user/v1/traingcenter/getInspectionDateExtension?${query}`;
		return this.apiService.get(url);
	}
	assignCIResidentialDate(datatoSend) {
		const url = `${environment.userServiceUrl}/api/user/v1/residential/addInspectiondate`;
		return this.apiService.put(url, datatoSend);
	}
	changeCI(datatoSend) {
		const url = `${environment.smartServiceURL}/api/smart/v1/trainingcentre/cm/ia/change/ci`;
		return this.apiService.put(url, datatoSend);
	}
	changeCIResidential(datatoSend) {
		const url = `${environment.userServiceUrl}/api/user/v1/residential/ia/change/ci`;
		return this.apiService.put(url, datatoSend);
	}
	generateOTP(datatoSend) {
		const url = `${environment.userServiceUrl}/api/user/reg/v1/generateOTP/Candidate`;
		return this.apiService.post(url, datatoSend);
	}

	patchApiTC_CAAF(data) {
		const tCUpdateApiUrl =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/UpdateForm";
		return this.apiService.patch(tCUpdateApiUrl, data, true);
	}
	updateAssessorUser(encPayload) {
		const url = `${environment.userServiceUrl}/api/user/v1/assessor`;
		return this.apiService.put(url, encPayload);
	}
	updatProctorUser(encPayload) {
		const url = `${environment.userServiceUrl}/api/user/v1/proctor`;
		return this.apiService.put(url, encPayload);
	}
	updateTrainerUser(encPayload) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainer`;
		return this.apiService.put(url, encPayload);
	}
	verifyTrainingCentreHubId(tcID) {
		const verifyURL = `${environment.userServiceUrl}/api/user/v1/trainingpartners/verify?TCID=${tcID}`;
		return this.apiService.get(verifyURL);
	}
	validatePmkkHubId(pmkkObj) {
		const pmkkVerifyURL = `${environment.userServiceUrl}/api/user/v1/trainingcentre/validate-pmkk-hub-id`;
		return this.apiService.post(pmkkVerifyURL, pmkkObj);
	}
	tcById(tcId) {
		const getTCDetailsURL =
			environment.userServiceUrl + "/api/user/v1/trainingcentre/" + tcId;
		return this.apiService.get(getTCDetailsURL);
	}
	approveTC(_id, body) {
		const approvalURL =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/workflow/" +
			_id;
		return this.apiService.patch(approvalURL, body);
	}
	actionTakenOnApplication(status, tcId) {
		const x = {
			tcstatus: status,
		};
		const url =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/Status/Update?tcId=" +
			tcId;
		return this.apiService.post(url, x);
	}
	actionTakenResidentialOnApplication(status, tcId) {
		const x = {
			tcstatus: status,
		};
		const url =
			environment.userServiceUrl +
			"/api/user/v1/residential/Status/Update?tcId=" +
			tcId;
		return this.apiService.post(url, x);
	}
	updateReview(status) {
		const url = environment.userServiceUrl + ``;
		return this.apiService.post(url, status);
	}
	updateJobRoles(userName, body) {
		// tslint:disable-next-line:max-line-length
		const classroomUpdateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/mobile/UpdateForm/slice?param=jobRoles&tcid=" +
			userName;
		return this.apiService.patch(classroomUpdateAPI, body, true);
	}
	unBlockTrainingCentre() {
		const unBlockAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/unblock/status";
		return this.apiService.patch(unBlockAPI, {});
	}

	showFeesAtDifferentStage(payload) {
		const amountAtDiffStage =
			environment.smartServiceURL + "/api/smart/v1/tccaaf/process/amount";
		return this.apiService.post(amountAtDiffStage, payload);
	}
	includeTCWithResidential(tcId, status) {
		const includeTCWithResidenUrl =
			environment.userServiceUrl +
			`/api/user/v1/residential/${tcId}/${status}`;
		return this.apiService.put(includeTCWithResidenUrl);
	}
	showFeesAtDifferentStageResidential(payload) {
		const amountAtDiffStage =
			environment.userServiceUrl + "/api/user/v1/residential/amount";
		return this.apiService.post(amountAtDiffStage, payload);
	}

	unBlockTrainingCentreResidential() {
		const unBlockAPI =
			environment.userServiceUrl +
			"/api/user/v1/residential/unblock/status";
		return this.apiService.patch(unBlockAPI, {});
	}
	assignIafromIaa(data) {
		const url =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/iaa/change/ia";
		return this.apiService.post(url, data);
	}
	reInspectionPayment(body, withResidential) {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/reInspection/payment?withResidential=" +
			withResidential;
		return this.apiService.post(updateAPI, body);
	}
	reInspectionResidentialPayment(body) {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/residential/reInspection/payment";
		return this.apiService.post(updateAPI, body);
	}
	drEditCaafPayment() {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/after/dr/payment";
		return this.apiService.post(updateAPI);
	}


	drEditResidentialPayment() {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/residential/after/dr/payment";
		return this.apiService.post(updateAPI);
	}
	getQualityControlBelogToMe() {
		const URL = environment.userServiceUrl + "/api/user/v1/qualitycontrol";
		return this.apiService.get(URL);
	}
	mobileAppLink() {
		const URL =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/get/mobile/link";
		return this.apiService.get(URL);
	}
	changeTrainer(payload) {
		const URL = environment.userServiceUrl + "/api/user/v1/changetrainer";
		return this.apiService.post(URL, payload);
	}
	tcCentreStatusUpdate(centreStatus) {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/UpdateForm";
		return this.apiService.patch(updateAPI, centreStatus, true);
	}
	inspectionAmountPending() {
		const inspectionpendingAmount =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/get/tcinspection/remainingfee";
		return this.apiService.get(inspectionpendingAmount);
	}
	remainigInspectionPayment() {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/add/tcinspection/remainingfee";
		return this.apiService.get(updateAPI);
	}
	paymentButtonDisablefor12Hr(reftype, userName) {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/paymentdetails/" +
			userName +
			"/check";
		return this.apiService.get(updateAPI);
	}
	getAbeasNiesbudStatus(tcId) {
		const updateAPI =
			environment.smartServiceURL +
			`/api/smart/v1/cond-acc/aebas-neisbud?tcId=${tcId}`;
		return this.apiService.get(updateAPI);
	}
	getSchemeNocEligiblity(query) {
		const updateAPI = environment.smartServiceURL + `/api/smart/v1/schemechange/istceligible`
		return this.apiService.get(updateAPI, query);
	}
	applySchemeNocEligiblity(payload) {
		const updateAPI =
			environment.smartServiceURL + `/api/smart/v1/schemechange/apply`;
		return this.apiService.post(updateAPI, payload);
	}
	autoAssignInspectionDate(datatoSend) {
		const url = `${environment.userServiceUrl}/api/user/v1/traingcenter/addInspectiondate/after/reject/${datatoSend.workflowID}`;
		return this.apiService.post(url, datatoSend);
	}
	autoAssignResidentialInspectionDate(datatoSend) {
		const url = `${environment.userServiceUrl}/api/user/v1/residential/addInspectiondate/after/reject/${datatoSend.workflowID}`;
		return this.apiService.post(url, datatoSend);
	}
	reAccriditationPayment(payload?) {
		const URL =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/reAccrediation/payment";
		let body = payload ? payload : {};
		return this.apiService.post(URL, body);
	}

	getTrainingCentreList(data) {
		const scheme = "SchemeBased";
		const param = "userName,trainingCentreName";
		const url = `${environment.userServiceUrl}/api/user/v1/autosuggest/trainingcentres?query=trainingPartner.userName:${data.userName},status:${data.status},trainingCentreName:${data.tcName}&Scheme=${scheme}&SchemeId=${data.selectedSchemeId}&pageNo=${data.pageNo}&limit=${data.itemsPerPage}&param=${param}&linkTc=${data.linkTc}`;
		return this.apiService.get(url);
	}

	linkTrainingCenterToProject(data) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/link/project`;
		return this.apiService.post(url, data);
	}
	activeOrIactiveJobRole(qpObj) {
		const jobRoleUrl = `${environment.smartServiceURL}/api/smart/v1/qpactiveorinactive`
		return this.apiService.patch(jobRoleUrl, qpObj, true)
	}
	changeTcCI(datatoSend) {
		const url = `${environment.userServiceUrl}/api/user/v1/traingcenter/ia/change/ci`;
		return this.apiService.put(url, datatoSend);
	}
	updateUserInfo(data) {
		const url = `${environment.smartServiceURL}/api/smart/v1/updateemailorphone/changeemailandphone`;
		return this.apiService.post(url, data);
	}

	createEnumerator(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/createActor/enumerator`;
		return this.apiService.post(URL, payload);
	}

	updateEnumerator(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/update/enumerator`;
		return this.apiService.put(URL, payload, true);
	}

	getEnumeratorList(payload?) {
		const URL = `${environment.userServiceUrl}/api/user/v1/enumerator`; //TODO:
		return this.apiService.post(URL, payload);
	}

	deactivateEnumerator(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/enumerator/status`; //TODO:
		return this.apiService.put(URL, payload);
	}

	createGpSpoc(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/createActor/gpspoc`;
		return this.apiService.post(URL, payload);
	}

	updateGpSpoc(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/update/gpspoc`;
		return this.apiService.put(URL, payload, true);
	}

	getGpSpocList(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/gpspoc`; //TODO:
		return this.apiService.post(URL, payload);
	}

	deactivateGpSpoc(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/gpspoc/status`; //TODO:
		return this.apiService.put(URL, payload);
	}

	createDsc(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/createActor/dsc`;
		return this.apiService.post(URL, payload);
	}

	updateDsc(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/update/dsc`;
		return this.apiService.put(URL, payload, true);
	}

	getDscList(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/dsc`; //TODO:
		return this.apiService.post(URL, payload);
	}

	deactivateDsc(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/dsc/status`; //TODO:
		return this.apiService.put(URL, payload);
	}

	registerEnumeratorCandidate(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/enumerator/temp-candidate`;
		return this.apiService.post(URL, payload);
	}

	getRegisteredCandidates(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/enumerator/temp-candidate/list`;
		return this.apiService.post(URL, payload);
	}

	approveCandidate(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/enumerator/temp-candidate/action`;
		return this.apiService.put(URL, payload);
	}

	updateCandidateBenefits(payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/aadarsh-gram/candidate-benifit`;
		return this.apiService.post(URL, payload);
	}

	getCandidateBenefits(username, batchId) {
		const URL = `${environment.userServiceUrl}/api/user/v1/aadarsh-gram/candidate-benifit/${username}/${batchId}`;
		return this.apiService.get(URL);
	}

	uploadCandidateAttendance(batchId, payload) {
		const URL = `${environment.userServiceUrl}/v1/candidates/batch/${batchId}/upload/attendance`;
		return this.apiService.post(URL, payload);
	}

	getCandidateAttendance(batchId, filter) {
		const URL = `${environment.userServiceUrl}/v1/candidates/batch/${batchId}/candidate/attendance`;
		return this.apiService.get(URL, filter);
	}

	downloadCandidateAttendance(batchId, filter) {
		const URL = `${environment.userServiceUrl}/v1/candidates/batch/${batchId}/candidate/attendance?download=true&startDate=${filter.startDate}&endDate=${filter.endDate}`;
		return this.apiService.getBlob(URL, filter);
	}

	getBatcheListForMohua(pageNo, itemsPerPage, filter?) {
		const query = {
			pageNo: pageNo,
			itemsPerPage: itemsPerPage,
			batchId: filter && filter.batchId ? filter.batchId : "",
		};
		const url = `${environment.userServiceUrl}/api/batch/v1/list/batches/mohua/rplsp`;
		return this.apiService.get(url, query);
	}

	updateCanBocwNumberForMohua(payload) {
		const url = `${environment.userServiceUrl}/api/batch/v1/batch/${payload.id}/candidate/${payload.candidateID}/${payload.bocwCardNumber}`;
		return this.apiService.post(url);
	}

	verifyCertificateDocument(batchId, payload) {
		const URL = `${environment.userServiceUrl}/v1/candidates/batch/${batchId}/certificateVerification`;
		return this.apiService.put(URL, payload);
	}

	verifyPlacementDocument(batchId, payload) {
		const URL = `${environment.userServiceUrl}/v1/candidates/batch/${batchId}/placementdocVerification`;
		return this.apiService.put(URL, payload);
	}

	submitAwardingBodyProfile(payload, userName) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/register/awardingbody`;
		return this.apiService.post(URL, payload);
	}

	updateAwardingBodyProfile(payload, userName) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/register/awardingbody`;
		return this.apiService.patch(URL, payload);
	}

	getAwardingBodyProfile(userName) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/awardingbody_details?userName=${userName}`;
		return this.apiService.get(URL);
	}

	getAwardingBodyReqList(query) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/abworkflow`;
		return this.apiService.get(URL, query);
	}
	getSscSpoc(query) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/ssc/spoc`;
		return this.apiService.get(URL, query);
	}

	checkPanNumberExist(query) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/checkpanexits?role=${query.role}&userName=${query.userName}&panNumber=${query.panNumber}`;
		return this.apiService.get(URL);
	}

	checkGstNumberExist(query) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/checkgstexits?role=${query.role}&userName=${query.userName}&gst=${query.gstNumber}`;
		return this.apiService.get(URL);
	}
	checkQPPrefixExist(query) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/checkQpPrefix`;
		return this.apiService.get(URL, query);
	}

	approveAwardingBodyReq(payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/abworkflow`;
		return this.apiService.post(URL, payload);
	}

	implementationPartnerRegistration(payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/register/implementation_partner`;
		return this.apiService.post(URL, payload);
	}

	getImplementationPartnerList(query) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/implementation_partners`;
		return this.apiService.get(URL, query);
	}

	getImplementationPartnerProfile(userName) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/implementation_partners_details?userName=${userName}`;
		return this.apiService.get(URL);
	}

	updateImplementationPartner(userName, payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/implementation_partners_details?userName=${userName}`;
		return this.apiService.post(URL, payload);
	}

	allocateTargetImplementationPartner(userName, payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/allocateTarget_IP?userName=${userName}`;
		return this.apiService.post(URL, payload);
	}
	allocateTargetTP(payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/allocateTarget_TP`;
		return this.apiService.post(URL, payload);
	}
	getSingleallocatedTargetTP(query) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/allocateTarget_TP/single`;
		return this.apiService.get(URL, query);
	}

	getAllocateTargetImplementationPartner(query) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/user/allocateTarget_TP`;
		return this.apiService.get(URL, query);
	}

	searchTps(pageNo, itemsPerPage, tpID?, tpName?) {
		if (tpID === "") {
			this.Query = "requesteeName:" + tpName;
		} else if (tpName === "") {
			this.Query = "tpID:" + tpID;
		} else {
			this.Query = "tpID:" + tpID + "," + "requesteeName:" + tpName;
		}

		// tslint:disable-next-line:max-line-length
		this.URI = `${environment.userServiceUrl}/api/user/v1/schemetpworkflow?pageNo=${pageNo}&limit=${itemsPerPage}&status=APPROVED&query=${this.Query}`;

		if (tpID === "" && tpName === "") {
			this.URI = `${environment.userServiceUrl}/api/user/v1/schemetpworkflow?pageNo=${pageNo}&limit=${itemsPerPage}&status=APPROVED`;
		}

		return this.apiService.get(this.URI);
	}

	getAllUsers(roles, pageNo, itemsPerPage, searchUser?) {
		let getAllUsersUrl = `${environment.userServiceUrl}/api/user/v1/getAllUsersBasedOnRole`;
		for (let i = 0; i < roles.length; i++) {
			if (i === 0) {
				getAllUsersUrl += "?";
			} else {
				getAllUsersUrl += "&";
			}
			getAllUsersUrl += "roles=" + roles[i];
		}
		getAllUsersUrl +=
			"&pageNo=" +
			pageNo +
			"&itemsPerPage=" +
			itemsPerPage +
			"&searchUser=";
		if (searchUser !== undefined) {
			getAllUsersUrl += searchUser;
		}
		return this.apiService.get(getAllUsersUrl);
	}

	getTpDetailsbyID(tpId) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/${tpId}`;
		return this.apiService.get(URL);
	}

	getTpListSchemeBased(query) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/getTPData/BySchemeDetails`;
		return this.apiService.get(URL, query);
	}

	getNsdcAdminPartnerList(pageNo, limit, payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/getusersbyfilterssip?pageno=${pageNo}&limit=${limit}`;
		return this.apiService.post(URL, payload);
	}

	getNsdcAdminPartnerDetails(mobileNumber) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/getsingleuserforpmu?mobileNumber=${mobileNumber}`
		return this.apiService.get(URL);
	}

	getServicesForNsdcAdminPartner() {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/getservicessip`
		return this.apiService.get(URL);
	}

	updateCanEpfNumberForMohua(payload) {
		const url = `${environment.userServiceUrl}/api/batch/v1/update/epfid/batch/${payload.id}/candidate/${payload.candidateID}/${payload.epfId}`;
		return this.apiService.post(url);
	}

	getListOfCandidates(payload) {
		const url = `${environment.userServiceUrl}/api/batch/v1/cma/batchCandidateDetails?
		pageNo=${payload.pageNo}&limit=${payload.limit}&batchId=${payload.batchId}&candidateId=${payload.candidateId}`;
		return this.apiService.get(url);
	}

	getOtpForACBP(otpInfo) {
		const URL = `${environment.userServiceUrl}/api/user/reg/v1/generateOTP/ACBP`;
		return this.apiService.post(URL, otpInfo)
	}

	verifyOtpForACBP(phoneotp: number, emailotp: number, payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/register/ACBP/phoneotp/${phoneotp}/emailotp/${emailotp}`;
		return this.apiService.post(URL, payload);
	}

	registrationForACBP(registrationData: IRegistration) {
		const URL = `${environment.userServiceUrl}/api/user/v1/acbp/register`;
		return this.apiService.post(URL, registrationData);
	}

	checkOnlineTCExists(schemeId) {
		const URL = `${environment.userServiceUrl}/api/user/v1/online/trainingcentre/check/${schemeId}`;
		return this.apiService.get(URL);
	}

	checkParentProjectCloser(tcId) {
		const URL = `${environment.userServiceUrl}/api/user/v1/check/parentprojectcloser/for/tc?tcId=${tcId}`
		return this.apiService.get(URL);
	}

	panNsdlVerification(query) {
		const url = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/panverificationsip?${query}`;
		return this.apiService.post(url);
	}

	gstNsdlVerification(body) {
		const url = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/gstverificationsip`;
		return this.apiService.post(url, body);
	}

	gstNsdlDetailsVerification(body) {
		const url = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/gstDetails`;
		return this.apiService.post(url, body);
	}

	agiCodeVerification(query) {
		const url = `${environment.smartServiceURL}/api/smart/v1/getDataByAgriUniqueCode`;
		return this.apiService.get(url, query);
	}

	addJobRoleInTCInAB(payload, userName?) {
		const URL = `${environment.smartServiceURL}/api/smart/v1/tccaaf/awardingbody/arraydata?userName=${userName}&key=jobRoles`;
		return this.apiService.put(URL, payload);
	}

	removeJobRoleInTCInAB(payload, userName?) {
		const URL = `${environment.smartServiceURL}/api/smart/v1/tccaaf/awardingbody/arraydata?userName=${userName}&key=jobRoles&serialnumber=${payload.serialNumber}`;
		return this.apiService.delete(URL, payload);
	}
	addJobRoleForNonAATC(tcUserName, payload) {
		const URL = `${environment.userServiceUrl}/api/user/v1/add/jobrole/${tcUserName}`;
		return this.apiService.put(URL, payload)
	}

	getNoNAATCJobRole(data) {
		const URL = `${environment.userServiceUrl}/api/user/v1/tc/jobrole/workflow?
		schemeId=${data.schemeId}&pageNo=${data.pageNo}&limit=${data.limit}&
		tpId=${data.tpId}&tcId=${data.tcId}&projectId=${data.projectId}
		&status=${data.status}`;
		return this.apiService.get(URL);
	}

	takeActionOnNonAATCJobRole(tcId, payload, workflowID?) {
		const url = `${environment.userServiceUrl}/api/user/v1/review/jobrole/nonAnATC/${tcId}?workflowID=${workflowID}`;
		return this.apiService.post(url, payload);
	}

	downloadABProfileAsPDF(userName) {
		const url = `${environment.pdfGenerate}/api/v1/generatepdfreports/awarding_body?userName=${userName}`;
		return this.apiService.get(url);
	}
	// Update target on PMU SHUFFLE TARGET
	updateTrainingTargets(payload) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/targetShuffle`;
		return this.apiService.put(url, payload);
	}

	enrollApplicantForPMKVY(batchId, status, tpId, payload) {
		const URL = `${environment.userServiceUrl}/api/batch/v1/enroll/tota/${batchId}/candidates?status=${status}&tpId=${tpId}`
		return this.apiService.patch(URL, payload)
	}
	updateCanInSchoolOutSchool(payload) {
		const url = `${environment.userServiceUrl}/api/batch/v1/batch/${payload.batchId}/candidateSchoolType/${payload.candidateId}/${payload.inSchoolOutSchoolType}`;
		return this.apiService.post(url);
	}

	deleteDraftApplicant(batchId, payload) {
		const url = `${environment.userServiceUrl}/api/batch/v1/remove/tota/draft/${batchId}/candidate`;
		return this.apiService.put(url, payload);
	}

	updateTCData(data, tcId) {
		const updateAPI =
			environment.userServiceUrl +
			"/api/user/v1/trainingcentre/UpdateForm?tcId=" + tcId;

		return this.apiService.patch(updateAPI, data, true);
	}
	feesBypassNsdcTc(payload) {
		const URL = environment.userServiceUrl + '/api/user/v1/skipUpdatePaymentStatus'
		return this.apiService.post(URL, payload);
	}
	feesBypassNsdcTcReAcc(payload) {
		const URL = environment.userServiceUrl + '/api/user/v1/trainingcentre/reAccrediation/withoutPayment'
		return this.apiService.post(URL, payload);
	}

	aadharVerificationAndOTP(payload) {
		const URL = environment.userManagmentServiceUrl + '/api/v2/nodeusermanagement/guru/verifyAadhar'
		return this.apiService.post(URL, payload)
	}

	aadharOTPVerifyToGetDetails(payload) {
		const URL = environment.userManagmentServiceUrl + '/api/v2/nodeusermanagement/guru/aadharotpverify'
		return this.apiService.post(URL, payload)
	}

	submitGuruTrainerDetails(payload) {
		const URL = environment.userManagmentServiceUrl + '/api/v2/nodeusermanagement/guru/addgurutrainer'
		return this.apiService.post(URL, payload)
	}

	getAllGuruTrainerList(payload) {
		const getAPI = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/guru/getallgurutrainer?limit=${payload.limit}&page=${payload.page}&status=${payload.status}&state=${payload.filters.state}&district=${payload.filters.district}&rdscId=${payload.filters.rdscID}`;
		return this.apiService.get(getAPI);
	}

	getDetailGuruTrainer(payload) {
		const getAPI = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/guru/getsinglegurutrainer?userName=${payload.userName}`;
		return this.apiService.get(getAPI);
	}

	getTradeForGuru() {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/guru/gettradelisting`
		return this.apiService.get(URL)
	}

	generateGuruCertificate(payload) {
		const URL = `${environment.batchServiceUrl}/api/v1/cert/gurucert/gurutrainercert`
		return this.apiService.post(URL, payload)
	}

	updateRdscRequest(payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/guru/updaterdscrequest`
		return this.apiService.post(URL, payload)
	}

	rdscExcelDownload(payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/guru/rdscguruExcel?status=${payload.status}`
		return this.apiService.getBlob(
			URL,
			"application/vnd.ms-excel"
		);
	}
	resubmitGuruTrainerRequest(payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/guru/resubmitrequest`
		return this.apiService.post(URL, payload)
	}

	getProjectListForTranch(data) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/get/tranch/documents?
		tpID=${data.tpId ? data.tpId : ""}
		&status=${data.status}
		&projectId=${data.projectId ? data.projectId : ""}
		&projectName=${data.projectName ? data.projectName : ""}`;
		return this.apiService.get(URL);
	}

	uploadTranchDocument(data) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/${data.userName}/tranch/document/${data.projectId}`;
		return this.apiService.post(url, data.payload);
	}

	reviewTranchDocument(userName, projectId, payload) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/${userName}/review/document/${projectId}`;
		return this.apiService.post(url, payload);
	}

	updateCanShowInterestInAdvance(payload) {
		const url = `${environment.userServiceUrl}/api/batch/v1/batch/candidateInterestedInAdvance/${payload.candidateId}/${payload.candidateInterestedInAdvance}/${payload.batchId}`;
		return this.apiService.post(url);
	}

	getToolKitDeliveryStatus(query) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/getDeliverKitConfirm`
		return this.apiService.post(URL, query)
	}

	updateToolKitAcknowledge(payload) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/updateToolKitAcknowledge`
		return this.apiService.post(URL, payload)
	}
	submitTrainerNomination(payload: any){
		const URL = `${environment.userManagmentServiceUrl}/api/user/nomination`
		return this.apiService.post(URL, payload)
	}
	getTradeCount(type: string, district: number) {
		const URL = `${environment.userManagmentServiceUrl}/api/v2/nodeusermanagement/getTradeCount/${type}/${district}`
		return this.apiService.get(URL);
	}

}


